import { render, staticRenderFns } from "./PrintGiftcards.vue?vue&type=template&id=8ae85cb4&scoped=true"
import script from "./PrintGiftcards.vue?vue&type=script&lang=js"
export * from "./PrintGiftcards.vue?vue&type=script&lang=js"
import style0 from "./PrintGiftcards.vue?vue&type=style&index=0&id=8ae85cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae85cb4",
  null
  
)

export default component.exports